import { useSelector } from "react-redux";
import { selectAllPropPresets } from "../app/slices/TrainingSlice";
import { selectUsedProps } from "../app/slices/PropLibrarySlice";

/** Display unresolved references without changing the stored interaction. */
export default function PropReferenceLabel({ instanceId }: { instanceId: string }) {
  const presets = useSelector(selectAllPropPresets);
  const usedProps = useSelector(selectUsedProps);
  const preset = presets.find((prop) => prop.id === instanceId);

  if (!instanceId) return <>No Prop</>;
  if (!preset) return <span className="text-creator-error">Missing Prop</span>;

  return (
    <span>
      {preset.name}
      {!usedProps[preset.propId]?.metadata && (
        <span className="block text-creator-error">Prop details unavailable.</span>
      )}
    </span>
  );
}
